// components/PlanDetailsCard.js
import React from 'react';
import { Card, CardBody } from 'reactstrap';

export default function PlanDetailsCard({ plan }) {
  if (!plan) return null;

  // Format price with 2 decimals
  const price = parseFloat(plan.price || 0).toFixed(2);
  const usersText = plan.users || '1 user';
  const billingText = plan.billing ? ` (${plan.billing})` : '';

  return (
    <Card className="mb-4">
      <CardBody>
        <h6 className="fw-bold mb-3">Plan details</h6>

        <div className="d-flex justify-content-between">
          <div>
            <div className="fw-semibold">
              {plan.name}
              {billingText}
            </div>
          </div>

          <div className="fw-semibold">${price}</div>
        </div>
        <div className="d-flex justify-content-between">
          <div>
            <div className="fw-semibold">Number of locations</div>
          </div>

          <div className="text-muted small">{usersText}</div>
        </div>
      </CardBody>
    </Card>
  );
}
